/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {convertFetchResponseToReactQueryResponse} from '../tools';
import {ApiResponse} from '../types';
import {
    useMutation,
    UseMutationOptions,
    UseMutationResult,
    useQuery,
    useQueryClient,
    UseQueryOptions,
    UseQueryResult,
    QueryClient,
    useInfiniteQuery,
    UseInfiniteQueryOptions,
    UseInfiniteQueryResult,
} from 'react-query';
import {
    AdminCreatePalletOrderRequest,
    AdminCreatePalletOrderRequestFromJSON,
    AdminCreatePalletOrderRequestToJSON,
    AdminCreatePalletOrderResponse,
    AdminCreatePalletOrderResponseFromJSON,
    AdminCreatePalletOrderResponseToJSON,
    AdminPalletOrder,
    AdminPalletOrderFromJSON,
    AdminPalletOrderToJSON,
    AdminPalletOrderLookupResponse,
    AdminPalletOrderLookupResponseFromJSON,
    AdminPalletOrderLookupResponseToJSON,
    AdminUpdatePalletOrderAttachmentMetaRequest,
    AdminUpdatePalletOrderAttachmentMetaRequestFromJSON,
    AdminUpdatePalletOrderAttachmentMetaRequestToJSON,
    AdminUpdatePalletOrderRequest,
    AdminUpdatePalletOrderRequestFromJSON,
    AdminUpdatePalletOrderRequestToJSON,
} from '../models';

import {
    AdminPalletOrderApi,
    AdminPalletOrderApiAdminCreatePalletRequest,
    AdminPalletOrderApiAdminCreatePalletOrderAttachmentRequest,
    AdminPalletOrderApiAdminDeletePalletOrderAttachmentRequest,
    AdminPalletOrderApiAdminDownloadPalletOrderAttachmentRequest,
    AdminPalletOrderApiAdminGetPalletRequest,
    AdminPalletOrderApiAdminPalletOrderLookupRequest,
    AdminPalletOrderApiAdminUpdatePalletRequest,
    AdminPalletOrderApiAdminUpdatePalletOrderAttachmentMetadataRequest,
} from './AdminPalletOrderApi';

type AdminCreatePalletQueryOptions = UseQueryOptions<
    AdminCreatePalletOrderResponse,
    Array<Error>,
    AdminCreatePalletOrderResponse,
    ['adminCreatePallet', AdminPalletOrderApiAdminCreatePalletRequest]
>;

let useAdminCreatePalletQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: AdminPalletOrderApiAdminCreatePalletRequest,
          options?: AdminCreatePalletQueryOptions
      ) => AdminCreatePalletQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminCreatePalletQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: AdminPalletOrderApiAdminCreatePalletRequest,
        options?: AdminCreatePalletQueryOptions
    ) => AdminCreatePalletQueryOptions | undefined
) {
    useAdminCreatePalletQueryGlobalOptions = callback;
}

export function getAdminCreatePalletQueryKey(
    params: AdminPalletOrderApiAdminCreatePalletRequest
): ['adminCreatePallet', AdminPalletOrderApiAdminCreatePalletRequest] {
    return ['adminCreatePallet', params];
}

export function useAdminCreatePalletQuery(
    params: AdminPalletOrderApiAdminCreatePalletRequest,
    options?: AdminCreatePalletQueryOptions
): UseQueryResult<AdminCreatePalletOrderResponse, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminCreatePalletQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminPalletOrderApi().adminCreatePallet(params, {signal})
            ),
        {
            ...options,
            ...useAdminCreatePalletQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type AdminCreatePalletMutationOptions = UseMutationOptions<
    AdminCreatePalletOrderResponse,
    Array<Error>,
    AdminPalletOrderApiAdminCreatePalletRequest
>;

let useAdminCreatePalletMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminCreatePalletMutationOptions
      ) => AdminCreatePalletMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminCreatePalletMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminCreatePalletMutationOptions
    ) => AdminCreatePalletMutationOptions | undefined
) {
    useAdminCreatePalletMutationGlobalOptions = callback;
}

export function useAdminCreatePalletMutation(
    options?: AdminCreatePalletMutationOptions
): UseMutationResult<
    AdminCreatePalletOrderResponse,
    Array<runtime.ApiError>,
    AdminPalletOrderApiAdminCreatePalletRequest
> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(await new AdminPalletOrderApi().adminCreatePallet(params)),
        {
            ...options,
            ...useAdminCreatePalletMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminCreatePalletInfiniteQueryKey(
    params: AdminPalletOrderApiAdminCreatePalletRequest
): ['adminCreatePallet-infinite', AdminPalletOrderApiAdminCreatePalletRequest] {
    return ['adminCreatePallet-infinite', params];
}

export function useAdminCreatePalletInfiniteQuery(
    params: AdminPalletOrderApiAdminCreatePalletRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            AdminCreatePalletOrderResponse,
            Array<runtime.ApiError>,
            AdminCreatePalletOrderResponse,
            AdminCreatePalletOrderResponse,
            ['adminCreatePallet-infinite', AdminPalletOrderApiAdminCreatePalletRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AdminCreatePalletOrderResponse, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminCreatePalletInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminPalletOrderApi().adminCreatePallet({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type AdminCreatePalletOrderAttachmentQueryOptions = UseQueryOptions<
    void,
    Array<Error>,
    void,
    ['adminCreatePalletOrderAttachment', AdminPalletOrderApiAdminCreatePalletOrderAttachmentRequest]
>;

let useAdminCreatePalletOrderAttachmentQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: AdminPalletOrderApiAdminCreatePalletOrderAttachmentRequest,
          options?: AdminCreatePalletOrderAttachmentQueryOptions
      ) => AdminCreatePalletOrderAttachmentQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminCreatePalletOrderAttachmentQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: AdminPalletOrderApiAdminCreatePalletOrderAttachmentRequest,
        options?: AdminCreatePalletOrderAttachmentQueryOptions
    ) => AdminCreatePalletOrderAttachmentQueryOptions | undefined
) {
    useAdminCreatePalletOrderAttachmentQueryGlobalOptions = callback;
}

export function getAdminCreatePalletOrderAttachmentQueryKey(
    params: AdminPalletOrderApiAdminCreatePalletOrderAttachmentRequest
): ['adminCreatePalletOrderAttachment', AdminPalletOrderApiAdminCreatePalletOrderAttachmentRequest] {
    return ['adminCreatePalletOrderAttachment', params];
}

export function useAdminCreatePalletOrderAttachmentQuery(
    params: AdminPalletOrderApiAdminCreatePalletOrderAttachmentRequest,
    options?: AdminCreatePalletOrderAttachmentQueryOptions
): UseQueryResult<void, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminCreatePalletOrderAttachmentQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminPalletOrderApi().adminCreatePalletOrderAttachment(params, {signal})
            ),
        {
            ...options,
            ...useAdminCreatePalletOrderAttachmentQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type AdminCreatePalletOrderAttachmentMutationOptions = UseMutationOptions<
    void,
    Array<Error>,
    AdminPalletOrderApiAdminCreatePalletOrderAttachmentRequest
>;

let useAdminCreatePalletOrderAttachmentMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminCreatePalletOrderAttachmentMutationOptions
      ) => AdminCreatePalletOrderAttachmentMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminCreatePalletOrderAttachmentMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminCreatePalletOrderAttachmentMutationOptions
    ) => AdminCreatePalletOrderAttachmentMutationOptions | undefined
) {
    useAdminCreatePalletOrderAttachmentMutationGlobalOptions = callback;
}

export function useAdminCreatePalletOrderAttachmentMutation(
    options?: AdminCreatePalletOrderAttachmentMutationOptions
): UseMutationResult<void, Array<runtime.ApiError>, AdminPalletOrderApiAdminCreatePalletOrderAttachmentRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminPalletOrderApi().adminCreatePalletOrderAttachment(params)
            ),
        {
            ...options,
            ...useAdminCreatePalletOrderAttachmentMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminCreatePalletOrderAttachmentInfiniteQueryKey(
    params: AdminPalletOrderApiAdminCreatePalletOrderAttachmentRequest
): ['adminCreatePalletOrderAttachment-infinite', AdminPalletOrderApiAdminCreatePalletOrderAttachmentRequest] {
    return ['adminCreatePalletOrderAttachment-infinite', params];
}

export function useAdminCreatePalletOrderAttachmentInfiniteQuery(
    params: AdminPalletOrderApiAdminCreatePalletOrderAttachmentRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            void,
            Array<runtime.ApiError>,
            void,
            void,
            ['adminCreatePalletOrderAttachment-infinite', AdminPalletOrderApiAdminCreatePalletOrderAttachmentRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<void, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminCreatePalletOrderAttachmentInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminPalletOrderApi().adminCreatePalletOrderAttachment({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type AdminDeletePalletOrderAttachmentQueryOptions = UseQueryOptions<
    void,
    Array<Error>,
    void,
    ['adminDeletePalletOrderAttachment', AdminPalletOrderApiAdminDeletePalletOrderAttachmentRequest]
>;

let useAdminDeletePalletOrderAttachmentQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: AdminPalletOrderApiAdminDeletePalletOrderAttachmentRequest,
          options?: AdminDeletePalletOrderAttachmentQueryOptions
      ) => AdminDeletePalletOrderAttachmentQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminDeletePalletOrderAttachmentQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: AdminPalletOrderApiAdminDeletePalletOrderAttachmentRequest,
        options?: AdminDeletePalletOrderAttachmentQueryOptions
    ) => AdminDeletePalletOrderAttachmentQueryOptions | undefined
) {
    useAdminDeletePalletOrderAttachmentQueryGlobalOptions = callback;
}

export function getAdminDeletePalletOrderAttachmentQueryKey(
    params: AdminPalletOrderApiAdminDeletePalletOrderAttachmentRequest
): ['adminDeletePalletOrderAttachment', AdminPalletOrderApiAdminDeletePalletOrderAttachmentRequest] {
    return ['adminDeletePalletOrderAttachment', params];
}

export function useAdminDeletePalletOrderAttachmentQuery(
    params: AdminPalletOrderApiAdminDeletePalletOrderAttachmentRequest,
    options?: AdminDeletePalletOrderAttachmentQueryOptions
): UseQueryResult<void, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminDeletePalletOrderAttachmentQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminPalletOrderApi().adminDeletePalletOrderAttachment(params, {signal})
            ),
        {
            ...options,
            ...useAdminDeletePalletOrderAttachmentQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type AdminDeletePalletOrderAttachmentMutationOptions = UseMutationOptions<
    void,
    Array<Error>,
    AdminPalletOrderApiAdminDeletePalletOrderAttachmentRequest
>;

let useAdminDeletePalletOrderAttachmentMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminDeletePalletOrderAttachmentMutationOptions
      ) => AdminDeletePalletOrderAttachmentMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminDeletePalletOrderAttachmentMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminDeletePalletOrderAttachmentMutationOptions
    ) => AdminDeletePalletOrderAttachmentMutationOptions | undefined
) {
    useAdminDeletePalletOrderAttachmentMutationGlobalOptions = callback;
}

export function useAdminDeletePalletOrderAttachmentMutation(
    options?: AdminDeletePalletOrderAttachmentMutationOptions
): UseMutationResult<void, Array<runtime.ApiError>, AdminPalletOrderApiAdminDeletePalletOrderAttachmentRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminPalletOrderApi().adminDeletePalletOrderAttachment(params)
            ),
        {
            ...options,
            ...useAdminDeletePalletOrderAttachmentMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminDeletePalletOrderAttachmentInfiniteQueryKey(
    params: AdminPalletOrderApiAdminDeletePalletOrderAttachmentRequest
): ['adminDeletePalletOrderAttachment-infinite', AdminPalletOrderApiAdminDeletePalletOrderAttachmentRequest] {
    return ['adminDeletePalletOrderAttachment-infinite', params];
}

export function useAdminDeletePalletOrderAttachmentInfiniteQuery(
    params: AdminPalletOrderApiAdminDeletePalletOrderAttachmentRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            void,
            Array<runtime.ApiError>,
            void,
            void,
            ['adminDeletePalletOrderAttachment-infinite', AdminPalletOrderApiAdminDeletePalletOrderAttachmentRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<void, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminDeletePalletOrderAttachmentInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminPalletOrderApi().adminDeletePalletOrderAttachment({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type AdminDownloadPalletOrderAttachmentQueryOptions = UseQueryOptions<
    Blob,
    Array<Error>,
    Blob,
    ['adminDownloadPalletOrderAttachment', AdminPalletOrderApiAdminDownloadPalletOrderAttachmentRequest]
>;

let useAdminDownloadPalletOrderAttachmentQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: AdminPalletOrderApiAdminDownloadPalletOrderAttachmentRequest,
          options?: AdminDownloadPalletOrderAttachmentQueryOptions
      ) => AdminDownloadPalletOrderAttachmentQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminDownloadPalletOrderAttachmentQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: AdminPalletOrderApiAdminDownloadPalletOrderAttachmentRequest,
        options?: AdminDownloadPalletOrderAttachmentQueryOptions
    ) => AdminDownloadPalletOrderAttachmentQueryOptions | undefined
) {
    useAdminDownloadPalletOrderAttachmentQueryGlobalOptions = callback;
}

export function getAdminDownloadPalletOrderAttachmentQueryKey(
    params: AdminPalletOrderApiAdminDownloadPalletOrderAttachmentRequest
): ['adminDownloadPalletOrderAttachment', AdminPalletOrderApiAdminDownloadPalletOrderAttachmentRequest] {
    return ['adminDownloadPalletOrderAttachment', params];
}

export function useAdminDownloadPalletOrderAttachmentQuery(
    params: AdminPalletOrderApiAdminDownloadPalletOrderAttachmentRequest,
    options?: AdminDownloadPalletOrderAttachmentQueryOptions
): UseQueryResult<Blob, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminDownloadPalletOrderAttachmentQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminPalletOrderApi().adminDownloadPalletOrderAttachment(params, {signal})
            ),
        {
            ...options,
            ...useAdminDownloadPalletOrderAttachmentQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type AdminDownloadPalletOrderAttachmentMutationOptions = UseMutationOptions<
    Blob,
    Array<Error>,
    AdminPalletOrderApiAdminDownloadPalletOrderAttachmentRequest
>;

let useAdminDownloadPalletOrderAttachmentMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminDownloadPalletOrderAttachmentMutationOptions
      ) => AdminDownloadPalletOrderAttachmentMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminDownloadPalletOrderAttachmentMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminDownloadPalletOrderAttachmentMutationOptions
    ) => AdminDownloadPalletOrderAttachmentMutationOptions | undefined
) {
    useAdminDownloadPalletOrderAttachmentMutationGlobalOptions = callback;
}

export function useAdminDownloadPalletOrderAttachmentMutation(
    options?: AdminDownloadPalletOrderAttachmentMutationOptions
): UseMutationResult<Blob, Array<runtime.ApiError>, AdminPalletOrderApiAdminDownloadPalletOrderAttachmentRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminPalletOrderApi().adminDownloadPalletOrderAttachment(params)
            ),
        {
            ...options,
            ...useAdminDownloadPalletOrderAttachmentMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminDownloadPalletOrderAttachmentInfiniteQueryKey(
    params: AdminPalletOrderApiAdminDownloadPalletOrderAttachmentRequest
): ['adminDownloadPalletOrderAttachment-infinite', AdminPalletOrderApiAdminDownloadPalletOrderAttachmentRequest] {
    return ['adminDownloadPalletOrderAttachment-infinite', params];
}

export function useAdminDownloadPalletOrderAttachmentInfiniteQuery(
    params: AdminPalletOrderApiAdminDownloadPalletOrderAttachmentRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            Blob,
            Array<runtime.ApiError>,
            Blob,
            Blob,
            [
                'adminDownloadPalletOrderAttachment-infinite',
                AdminPalletOrderApiAdminDownloadPalletOrderAttachmentRequest,
            ]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<Blob, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminDownloadPalletOrderAttachmentInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminPalletOrderApi().adminDownloadPalletOrderAttachment({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type AdminGetPalletQueryOptions = UseQueryOptions<
    AdminPalletOrder,
    Array<Error>,
    AdminPalletOrder,
    ['adminGetPallet', AdminPalletOrderApiAdminGetPalletRequest]
>;

let useAdminGetPalletQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: AdminPalletOrderApiAdminGetPalletRequest,
          options?: AdminGetPalletQueryOptions
      ) => AdminGetPalletQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminGetPalletQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: AdminPalletOrderApiAdminGetPalletRequest,
        options?: AdminGetPalletQueryOptions
    ) => AdminGetPalletQueryOptions | undefined
) {
    useAdminGetPalletQueryGlobalOptions = callback;
}

export function getAdminGetPalletQueryKey(
    params: AdminPalletOrderApiAdminGetPalletRequest
): ['adminGetPallet', AdminPalletOrderApiAdminGetPalletRequest] {
    return ['adminGetPallet', params];
}

export function useAdminGetPalletQuery(
    params: AdminPalletOrderApiAdminGetPalletRequest,
    options?: AdminGetPalletQueryOptions
): UseQueryResult<AdminPalletOrder, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminGetPalletQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new AdminPalletOrderApi().adminGetPallet(params, {signal})),
        {
            ...options,
            ...useAdminGetPalletQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type AdminGetPalletMutationOptions = UseMutationOptions<
    AdminPalletOrder,
    Array<Error>,
    AdminPalletOrderApiAdminGetPalletRequest
>;

let useAdminGetPalletMutationGlobalOptions:
    | ((queryClient: QueryClient, options?: AdminGetPalletMutationOptions) => AdminGetPalletMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminGetPalletMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminGetPalletMutationOptions
    ) => AdminGetPalletMutationOptions | undefined
) {
    useAdminGetPalletMutationGlobalOptions = callback;
}

export function useAdminGetPalletMutation(
    options?: AdminGetPalletMutationOptions
): UseMutationResult<AdminPalletOrder, Array<runtime.ApiError>, AdminPalletOrderApiAdminGetPalletRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(await new AdminPalletOrderApi().adminGetPallet(params)),
        {
            ...options,
            ...useAdminGetPalletMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminGetPalletInfiniteQueryKey(
    params: AdminPalletOrderApiAdminGetPalletRequest
): ['adminGetPallet-infinite', AdminPalletOrderApiAdminGetPalletRequest] {
    return ['adminGetPallet-infinite', params];
}

export function useAdminGetPalletInfiniteQuery(
    params: AdminPalletOrderApiAdminGetPalletRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            AdminPalletOrder,
            Array<runtime.ApiError>,
            AdminPalletOrder,
            AdminPalletOrder,
            ['adminGetPallet-infinite', AdminPalletOrderApiAdminGetPalletRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AdminPalletOrder, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminGetPalletInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminPalletOrderApi().adminGetPallet({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type AdminPalletOrderLookupQueryOptions = UseQueryOptions<
    AdminPalletOrderLookupResponse,
    Array<Error>,
    AdminPalletOrderLookupResponse,
    ['adminPalletOrderLookup', AdminPalletOrderApiAdminPalletOrderLookupRequest]
>;

let useAdminPalletOrderLookupQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: AdminPalletOrderApiAdminPalletOrderLookupRequest,
          options?: AdminPalletOrderLookupQueryOptions
      ) => AdminPalletOrderLookupQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminPalletOrderLookupQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: AdminPalletOrderApiAdminPalletOrderLookupRequest,
        options?: AdminPalletOrderLookupQueryOptions
    ) => AdminPalletOrderLookupQueryOptions | undefined
) {
    useAdminPalletOrderLookupQueryGlobalOptions = callback;
}

export function getAdminPalletOrderLookupQueryKey(
    params: AdminPalletOrderApiAdminPalletOrderLookupRequest
): ['adminPalletOrderLookup', AdminPalletOrderApiAdminPalletOrderLookupRequest] {
    return ['adminPalletOrderLookup', params];
}

export function useAdminPalletOrderLookupQuery(
    params: AdminPalletOrderApiAdminPalletOrderLookupRequest,
    options?: AdminPalletOrderLookupQueryOptions
): UseQueryResult<AdminPalletOrderLookupResponse, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminPalletOrderLookupQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminPalletOrderApi().adminPalletOrderLookup(params, {signal})
            ),
        {
            ...options,
            ...useAdminPalletOrderLookupQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type AdminPalletOrderLookupMutationOptions = UseMutationOptions<
    AdminPalletOrderLookupResponse,
    Array<Error>,
    AdminPalletOrderApiAdminPalletOrderLookupRequest
>;

let useAdminPalletOrderLookupMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminPalletOrderLookupMutationOptions
      ) => AdminPalletOrderLookupMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminPalletOrderLookupMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminPalletOrderLookupMutationOptions
    ) => AdminPalletOrderLookupMutationOptions | undefined
) {
    useAdminPalletOrderLookupMutationGlobalOptions = callback;
}

export function useAdminPalletOrderLookupMutation(
    options?: AdminPalletOrderLookupMutationOptions
): UseMutationResult<
    AdminPalletOrderLookupResponse,
    Array<runtime.ApiError>,
    AdminPalletOrderApiAdminPalletOrderLookupRequest
> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(await new AdminPalletOrderApi().adminPalletOrderLookup(params)),
        {
            ...options,
            ...useAdminPalletOrderLookupMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminPalletOrderLookupInfiniteQueryKey(
    params: AdminPalletOrderApiAdminPalletOrderLookupRequest
): ['adminPalletOrderLookup-infinite', AdminPalletOrderApiAdminPalletOrderLookupRequest] {
    return ['adminPalletOrderLookup-infinite', params];
}

export function useAdminPalletOrderLookupInfiniteQuery(
    params: AdminPalletOrderApiAdminPalletOrderLookupRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            AdminPalletOrderLookupResponse,
            Array<runtime.ApiError>,
            AdminPalletOrderLookupResponse,
            AdminPalletOrderLookupResponse,
            ['adminPalletOrderLookup-infinite', AdminPalletOrderApiAdminPalletOrderLookupRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AdminPalletOrderLookupResponse, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminPalletOrderLookupInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminPalletOrderApi().adminPalletOrderLookup({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type AdminUpdatePalletQueryOptions = UseQueryOptions<
    void,
    Array<Error>,
    void,
    ['adminUpdatePallet', AdminPalletOrderApiAdminUpdatePalletRequest]
>;

let useAdminUpdatePalletQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: AdminPalletOrderApiAdminUpdatePalletRequest,
          options?: AdminUpdatePalletQueryOptions
      ) => AdminUpdatePalletQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminUpdatePalletQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: AdminPalletOrderApiAdminUpdatePalletRequest,
        options?: AdminUpdatePalletQueryOptions
    ) => AdminUpdatePalletQueryOptions | undefined
) {
    useAdminUpdatePalletQueryGlobalOptions = callback;
}

export function getAdminUpdatePalletQueryKey(
    params: AdminPalletOrderApiAdminUpdatePalletRequest
): ['adminUpdatePallet', AdminPalletOrderApiAdminUpdatePalletRequest] {
    return ['adminUpdatePallet', params];
}

export function useAdminUpdatePalletQuery(
    params: AdminPalletOrderApiAdminUpdatePalletRequest,
    options?: AdminUpdatePalletQueryOptions
): UseQueryResult<void, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminUpdatePalletQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminPalletOrderApi().adminUpdatePallet(params, {signal})
            ),
        {
            ...options,
            ...useAdminUpdatePalletQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type AdminUpdatePalletMutationOptions = UseMutationOptions<
    void,
    Array<Error>,
    AdminPalletOrderApiAdminUpdatePalletRequest
>;

let useAdminUpdatePalletMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminUpdatePalletMutationOptions
      ) => AdminUpdatePalletMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminUpdatePalletMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminUpdatePalletMutationOptions
    ) => AdminUpdatePalletMutationOptions | undefined
) {
    useAdminUpdatePalletMutationGlobalOptions = callback;
}

export function useAdminUpdatePalletMutation(
    options?: AdminUpdatePalletMutationOptions
): UseMutationResult<void, Array<runtime.ApiError>, AdminPalletOrderApiAdminUpdatePalletRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(await new AdminPalletOrderApi().adminUpdatePallet(params)),
        {
            ...options,
            ...useAdminUpdatePalletMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminUpdatePalletInfiniteQueryKey(
    params: AdminPalletOrderApiAdminUpdatePalletRequest
): ['adminUpdatePallet-infinite', AdminPalletOrderApiAdminUpdatePalletRequest] {
    return ['adminUpdatePallet-infinite', params];
}

export function useAdminUpdatePalletInfiniteQuery(
    params: AdminPalletOrderApiAdminUpdatePalletRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            void,
            Array<runtime.ApiError>,
            void,
            void,
            ['adminUpdatePallet-infinite', AdminPalletOrderApiAdminUpdatePalletRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<void, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminUpdatePalletInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminPalletOrderApi().adminUpdatePallet({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type AdminUpdatePalletOrderAttachmentMetadataQueryOptions = UseQueryOptions<
    void,
    Array<Error>,
    void,
    ['adminUpdatePalletOrderAttachmentMetadata', AdminPalletOrderApiAdminUpdatePalletOrderAttachmentMetadataRequest]
>;

let useAdminUpdatePalletOrderAttachmentMetadataQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: AdminPalletOrderApiAdminUpdatePalletOrderAttachmentMetadataRequest,
          options?: AdminUpdatePalletOrderAttachmentMetadataQueryOptions
      ) => AdminUpdatePalletOrderAttachmentMetadataQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminUpdatePalletOrderAttachmentMetadataQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: AdminPalletOrderApiAdminUpdatePalletOrderAttachmentMetadataRequest,
        options?: AdminUpdatePalletOrderAttachmentMetadataQueryOptions
    ) => AdminUpdatePalletOrderAttachmentMetadataQueryOptions | undefined
) {
    useAdminUpdatePalletOrderAttachmentMetadataQueryGlobalOptions = callback;
}

export function getAdminUpdatePalletOrderAttachmentMetadataQueryKey(
    params: AdminPalletOrderApiAdminUpdatePalletOrderAttachmentMetadataRequest
): ['adminUpdatePalletOrderAttachmentMetadata', AdminPalletOrderApiAdminUpdatePalletOrderAttachmentMetadataRequest] {
    return ['adminUpdatePalletOrderAttachmentMetadata', params];
}

export function useAdminUpdatePalletOrderAttachmentMetadataQuery(
    params: AdminPalletOrderApiAdminUpdatePalletOrderAttachmentMetadataRequest,
    options?: AdminUpdatePalletOrderAttachmentMetadataQueryOptions
): UseQueryResult<void, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminUpdatePalletOrderAttachmentMetadataQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminPalletOrderApi().adminUpdatePalletOrderAttachmentMetadata(params, {signal})
            ),
        {
            ...options,
            ...useAdminUpdatePalletOrderAttachmentMetadataQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type AdminUpdatePalletOrderAttachmentMetadataMutationOptions = UseMutationOptions<
    void,
    Array<Error>,
    AdminPalletOrderApiAdminUpdatePalletOrderAttachmentMetadataRequest
>;

let useAdminUpdatePalletOrderAttachmentMetadataMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminUpdatePalletOrderAttachmentMetadataMutationOptions
      ) => AdminUpdatePalletOrderAttachmentMetadataMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminUpdatePalletOrderAttachmentMetadataMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminUpdatePalletOrderAttachmentMetadataMutationOptions
    ) => AdminUpdatePalletOrderAttachmentMetadataMutationOptions | undefined
) {
    useAdminUpdatePalletOrderAttachmentMetadataMutationGlobalOptions = callback;
}

export function useAdminUpdatePalletOrderAttachmentMetadataMutation(
    options?: AdminUpdatePalletOrderAttachmentMetadataMutationOptions
): UseMutationResult<
    void,
    Array<runtime.ApiError>,
    AdminPalletOrderApiAdminUpdatePalletOrderAttachmentMetadataRequest
> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminPalletOrderApi().adminUpdatePalletOrderAttachmentMetadata(params)
            ),
        {
            ...options,
            ...useAdminUpdatePalletOrderAttachmentMetadataMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminUpdatePalletOrderAttachmentMetadataInfiniteQueryKey(
    params: AdminPalletOrderApiAdminUpdatePalletOrderAttachmentMetadataRequest
): [
    'adminUpdatePalletOrderAttachmentMetadata-infinite',
    AdminPalletOrderApiAdminUpdatePalletOrderAttachmentMetadataRequest,
] {
    return ['adminUpdatePalletOrderAttachmentMetadata-infinite', params];
}

export function useAdminUpdatePalletOrderAttachmentMetadataInfiniteQuery(
    params: AdminPalletOrderApiAdminUpdatePalletOrderAttachmentMetadataRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            void,
            Array<runtime.ApiError>,
            void,
            void,
            [
                'adminUpdatePalletOrderAttachmentMetadata-infinite',
                AdminPalletOrderApiAdminUpdatePalletOrderAttachmentMetadataRequest,
            ]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<void, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminUpdatePalletOrderAttachmentMetadataInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminPalletOrderApi().adminUpdatePalletOrderAttachmentMetadata({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}
